import React, { useState, useEffect } from 'react';
import {
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalFormLabel,
    ModalForm,
    ImageGrid,
    SelectableImage,
    ModalCenterButton,
    ModalTextArea,
    ModalCloseButton,
    ModalButton,
    StoryMakerModalOverlay,
    OverviewBody,
    SpinningIcon,
    ModalOptionList,
    ModalOptionButton,
} from './StoryMakerElements';
import GenerateSceneAdaption from '../BedrockLibrary/SceneAdaption';
import GenerateCoverImage from '../BedrockLibrary/CoverGeneration';
import GeneratePrompt from '../BedrockLibrary/PromptGeneration';
import GeneratePageImagePrompt from '../BedrockLibrary/PageImagePrompt';
import GenerateSettingImage from '../BedrockLibrary/SettingGeneration';
import GenerateCohesiveImage from '../BedrockLibrary/CohesiveImageGeneration';
import GenerateSceneModification from '../BedrockLibrary/SceneModification';

const StoryMakerModal = ({ isOpen, onClose, onSave, story, firstPage = 0 }) => {

    const [pageNumber, setPageNumber] = useState(firstPage);
    const [storyData, setStoryData] = useState(story);
    const [imageOptions, setImageOptions] = useState();
    const [loadingBoolean, setLoadingBoolean] = useState(false);
    const [style, setStyle] = useState("")
    const [controlText, setControlText] = useState("");

    const [selectedOption, setSelectedOption] = useState('');

    const handleStyleSelection = (option) => {
        setStyle(option);
    }

    const handleNext = () => { setPageNumber(pageNumber + 1); setImageOptions() };
    const handlePrevious = () => { setPageNumber(pageNumber - 1); setImageOptions() };

    useEffect(() => {
        // console.log(story)
        setStoryData(story)
    }, [story]);

    const handleDetailsChange = (e) => {
        const { name, value } = e.target;
        setStoryData(prev => ({ ...prev, [name]: value }));
    };

    const handleChange = (e) => {
        const value = e.target.value;

        let new_pages = [...storyData.pages];
        new_pages[pageNumber - 1] = { ...new_pages[pageNumber - 1], text: value };
        setStoryData(prev => ({ ...prev, pages: new_pages }));
    };


    const handleDeletePage = (e) => {
        e.preventDefault();
        let new_pages = [...storyData.pages];
        new_pages.splice(pageNumber - 1, 1); // Remove the selected page
        setStoryData(prev => ({ ...prev, pages: new_pages }));
        setPageNumber(pageNumber - 1);
    };

    const handleAddPage = () => {
        let new_pages = [...storyData.pages];
        const blankPage = { text: "" }; // You can add other default properties if needed

        // Insert the blank page at the desired position
        new_pages.splice(pageNumber - 1, 0, blankPage);

        setStoryData(prev => ({ ...prev, pages: new_pages }));
    };


    const handleCoverCreation = async () => {
        setLoadingBoolean(true)
        // console.log(style)
        const prompt = await GeneratePrompt(story, style)
        // await GenerateCoverImage(setImageOptions, setLoadingBoolean, prompt, storyData, style);
        // console.log(prompt)
        await GenerateCohesiveImage(setImageOptions, prompt, style)
        setLoadingBoolean(false)
    };

    const handleImageSelection = async (e, img) => {
        e.preventDefault();
        const newStoryData = { ...storyData, img: img }
        // console.log(newStoryData)
        setStoryData(newStoryData)
        await onSave(e, newStoryData)
        setImageOptions()
    }


    const handleImageCreation = async () => {
        setLoadingBoolean(true)
        let new_pages = [...storyData.pages];

        if (storyData.pages[pageNumber - 1].img) {
            new_pages[pageNumber - 1] = { ...new_pages[pageNumber - 1], img: "" };
        }
        const prompt = await GeneratePageImagePrompt(story, pageNumber, style)

        setStoryData(prev => ({ ...prev, pages: new_pages }));
        // await GenerateSceneAdaption(setImageOptions, prompt, storyData.img)
        // await GenerateSettingImage(setImageOptions, prompt, style)
        await GenerateCohesiveImage(setImageOptions, prompt, style)
        setLoadingBoolean(false)
    };

    const handleImageModification = async () => {
        setLoadingBoolean(true);
        let new_pages = [...storyData.pages];
        const image = storyData.pages[pageNumber - 1].img

        if (storyData.pages[pageNumber - 1].img) {
            new_pages[pageNumber - 1] = { ...new_pages[pageNumber - 1], img: "" };
        }

        setStoryData(prev => ({ ...prev, pages: new_pages }));
        await GenerateSceneAdaption(setImageOptions, controlText, style, image)
        setLoadingBoolean(false)
    };


    const handlePageImageSelection = (e, img) => {
        e.preventDefault();
        // Update the current page with new image data
        // Copy the current pages
        let new_pages = [...storyData.pages];

        new_pages[pageNumber - 1] = { ...new_pages[pageNumber - 1], img: img };

        const newStoryData = { ...storyData, pages: new_pages }
        setStoryData(newStoryData);
        onSave(e, newStoryData)
        setImageOptions()
    }


    const handleClose = () => {
        setLoadingBoolean(false);
        setPageNumber(0);
        setImageOptions();
        onClose();
    }

    const handleSave = async (e, story) => {
        await onSave(e, story);
        setLoadingBoolean(false);
        onClose();
        // console.log(story)
    };

    if (!isOpen) return null;

    return (
        <StoryMakerModalOverlay>
            {storyData ?
                <>
                    {pageNumber === 0 && (
                        <ModalContainer hasImage={!!storyData.img} src={storyData.img}>
                            <ModalHeader>Overview</ModalHeader >
                            <ModalFormLabel >Title</ModalFormLabel>
                            <ModalForm type="text" name="title" value={storyData.title} onChange={handleDetailsChange} />
                            <OverviewBody>
                                <ModalFormLabel>Setting:</ModalFormLabel>
                                <ModalTextArea type="text" name="setting" value={storyData.setting} onChange={handleDetailsChange} />
                                {/* <ModalFormLabel>characters</ModalFormLabel>
                                <ModalForm type="text" name="characters" value={storyData.character_descriptions} onChange={handleChange} /> */}
                                <ModalFormLabel>Description:</ModalFormLabel>
                                <ModalTextArea style={{ 'min-height': '100px' }} type="text" name="description" value={storyData.description} onChange={handleDetailsChange} />
                                {
                                    imageOptions ?
                                        <>
                                            <ModalFormLabel>Select Cover Image</ModalFormLabel>
                                            <ImageGrid> {imageOptions.map((imgSrc, index) => (
                                                <SelectableImage key={index} src={imgSrc} alt={`Selectable ${index}`} onClick={(e) => handleImageSelection(e, imgSrc)} />))}
                                            </ImageGrid>
                                        </>
                                        : (<>
                                            {loadingBoolean && (
                                                <SpinningIcon />
                                            )}
                                            <ModalOptionList>
                                                <ModalOptionButton selected={style === 'Water Color'} onClick={() => handleStyleSelection('Water Color')}>Water Color</ModalOptionButton>
                                                <ModalOptionButton selected={style === 'Cartoon'} onClick={() => handleStyleSelection('Cartoon')}>Cartoon</ModalOptionButton>
                                                <ModalOptionButton selected={style === 'Hyper Realistic'} onClick={() => handleStyleSelection('Hyper Realistic')}>Realistic</ModalOptionButton>
                                            </ModalOptionList>
                                            <ModalCenterButton onClick={handleCoverCreation}>Generate Cover</ModalCenterButton>
                                        </>
                                        )
                                }
                            </OverviewBody>
                            <ModalFooter>
                                <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                                <ModalButton onClick={handleNext}>Next</ModalButton>
                            </ModalFooter>
                        </ModalContainer>
                    )}
                    {pageNumber > 0 && (
                        storyData.pages[pageNumber - 1].img ?
                            <ModalContainer hasImage={true} src={storyData.pages[pageNumber - 1].img}>
                                < ModalHeader > {storyData.title}</ModalHeader >
                                < ModalBody >
                                    <ModalTextArea type="text" name="pages" value={storyData.pages[pageNumber - 1].text} onChange={handleChange} />
                                    {loadingBoolean && (
                                        <SpinningIcon />
                                    )}
                                    <ModalButton disabled={!!loadingBoolean} onClick={() => handleImageCreation()}>Generate Image</ModalButton>
                                    <ModalTextArea style={{ marginBottom: '3px', marginTop: '6px', minHeight: '25px' }} type="text" name="mod" value={controlText} onChange={(e) => setControlText(e.target.value)} />
                                    <ModalButton disabled={!!loadingBoolean} onClick={() => handleImageModification()}>Modify Image</ModalButton>
                                </ModalBody >
                                <ModalFooter>
                                    <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                                    <ModalButton onClick={(e) => handleAddPage(e)}>Add Page</ModalButton>
                                    <ModalButton onClick={(e) => handleDeletePage(e)}>Delete Page</ModalButton>
                                    {pageNumber > 0 && <ModalButton onClick={handlePrevious}>Previous</ModalButton>}
                                    {pageNumber < storyData.pages.length ? (
                                        <ModalButton onClick={handleNext}>Next</ModalButton>
                                    ) : (
                                        <ModalButton onClick={(e) => handleSave(e, storyData)}>Save</ModalButton>
                                    )}
                                </ModalFooter>
                            </ModalContainer >
                            : (
                                <ModalContainer>
                                    < ModalHeader > {storyData.title}</ModalHeader >
                                    < ModalBody >
                                        {imageOptions &&
                                            <>
                                                <ModalFormLabel>Select Image</ModalFormLabel>
                                                <ImageGrid> {imageOptions.map((imgSrc, index) => (
                                                    <SelectableImage key={index} src={imgSrc} alt={`Selectable ${index}`} onClick={(e) => handlePageImageSelection(e, imgSrc)} />))}
                                                </ImageGrid>
                                            </>
                                        }
                                        <ModalTextArea type="text" name="pages" value={storyData.pages[pageNumber - 1].text} onChange={handleChange} />
                                        {loadingBoolean && (
                                            <SpinningIcon />
                                        )}
                                        <ModalButton disabled={!!loadingBoolean} onClick={() => handleImageCreation()}>Generate Image</ModalButton>
                                    </ModalBody >
                                    <ModalFooter>
                                        <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                                        <ModalButton onClick={(e) => handleAddPage(e)}>Add Page</ModalButton>
                                        <ModalButton onClick={(e) => handleDeletePage(e)}>Delete Page</ModalButton>
                                        {pageNumber > 0 && <ModalButton onClick={handlePrevious}>Previous</ModalButton>}
                                        {pageNumber < storyData.pages.length ? (
                                            <ModalButton onClick={handleNext}>Next</ModalButton>
                                        ) : (
                                            <ModalButton onClick={(e) => handleSave(e, storyData)}>Save</ModalButton>
                                        )}
                                    </ModalFooter>
                                </ModalContainer >))}
                </>
                : <></>}
        </StoryMakerModalOverlay >
    );
};


export default StoryMakerModal;
